import React from 'react'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'

export default function IsStep ({ is, children }) {

  const { step } = React.useContext(LoanCalculatorContext)

  if (step !== is) {
    return null
  }

  return children
}
